import { defineStore } from "pinia";

export interface Menu {
  icon?: string;
  type?: string;
  title: string;
  badge?: number;
  pageName?: string;
  subMenu?: Menu[];
  ignore?: boolean;
  roles?: string[];
}

export interface MenuState {
  value: Array<Menu | string>;
}

export const useMenuStore = defineStore("menu", {
  state: (): MenuState => ({
    value: [
      { title: "menu.section_dashboard", type: "divider" },
      { icon: "GaugeCircle", pageName: "dashboard", title: "menu.dashboard" },
      { icon: "Search", pageName: "genealogy.search", title: "menu.genealogy_search" },
      {
        icon: "ClipboardCheck",
        pageName: "genealogy.review",
        title: "menu.genealogy_review",
        roles: ["ADMIN"],
      },
      {
        icon: "MapPin",
        pageName: "genealogy.geography",
        title: "menu.genealogy_geography",
        roles: ["ADMIN"],
      },
      { title: "menu.section_user_management", type: "divider", roles: ["ADMIN"] },
      {
        icon: "Users",
        title: "menu.users",
        roles: ["ADMIN"],
        subMenu: [{ icon: "User", title: "menu.users_list", pageName: "users" }],
      },
      { title: "menu.section_system", type: "divider", roles: ["ADMIN"] },
      { icon: "Settings", pageName: "system-settings", title: "menu.settings", roles: ["ADMIN"] },
      { icon: "ShieldCheck", pageName: "audit", title: "menu.audit", roles: ["ADMIN"] },
      { icon: "Activity", pageName: "system-logs", title: "menu.system_logs", roles: ["ADMIN"] },
    ],
  }),
});
